import {BaseSearchDTO} from "../API/index";

export interface UInspectSearchDTO extends BaseSearchDTO {
  filters?: {
    id: number,
    uInspectSource: string,
    externalAppraisalCode: string,
  };
}
